<template>
  <v-layout
    row
    justify-center
    align-center
    class="authenticator-container"
  >
    <v-card
      min-width="460"
      class="px-4 py-4"
    >
      <v-card-title>
        <h2>Sign Up Account</h2>
      </v-card-title>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-select
            v-if="!isCognitoType"
            v-model="appId"
            :items="applications"
            :rules="[v => !!v || 'Application client ID is required']"
            label="Application client ID "
            required
          />
          <v-text-field
            v-model="email"
            :rules="emailRules"
            label="Email"
            required
          />
          <v-text-field
            v-model="password"
            :append-icon="passwordVisible ? 'visibility' : 'visibility_off'"
            :rules="[passwordRules.required, passwordRules.min]"
            :type="passwordVisible ? 'text' : 'password'"
            name="password"
            label="Password"
            hint="At least 8 characters"
            counter
            required
            @click:append="passwordVisible = !passwordVisible"
          />
          <v-text-field
            v-model="phoneNumber"
            :rules="phoneRules"
            label="Phone Number"
            required
          />

          <v-layout
            row
            justify-space-between
            align-center
            class="mt-2"
          >
            <div>
              Have an account?
              <router-link
                :to="{ path: '/login', query: isCognitoType ? { type: 'cognito'} : null }"
              >
                Sign In
              </router-link>
            </div>
            <e-button
              color="primary"
              text="Create Account"
              :loading="isSubmit"
              :disabled="!valid || isSubmit"
              @click="submit"
            />
          </v-layout>
        </v-form>

        <v-alert
          v-if="error"
          type="error"
          :value="true"
          class="mt-2"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import { signUp } from '@/utils/auth';
import { Button } from '@/components/shared';

export default {
  name: 'SignUp',
  components: {
    'e-button': Button,
  },
  data() {
    return {
      valid: false,
      isSubmit: false,
      isCognitoType: false,
      email: '',
      password: '',
      phoneNumber: '',
      error: '',
      appId: '1',
      applications: [
        { text: 'Exporo AG', value: '1' },
        { text: 'Accontis', value: '4' },
      ],
      passwordVisible: false,
    };
  },
  computed: {
    emailRules() {
      return [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ];
    },
    passwordRules() {
      return {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => ('The email and password you entered don\'t match'),
      };
    },
    phoneRules() {
      return [
        v => !!v || 'Phone number is required',
      ];
    },
  },
  watch: {
    $route(to) {
      this.error = '';
      this.checkLoginType(to.query);
    },
  },
  created() {
    this.checkLoginType(this.$route.query);
  },
  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        const username = this.concatUsername(this.appId, this.email);
        try {
          this.isSubmit = true;
          await signUp({
            username,
            password: this.password,
            attributes: {
              email: this.email,
              'custom:app_client_id': this.appId,
              phone_number: this.phoneNumber,
            },
          });
          this.isSubmit = false;
        } catch (err) {
          this.setError(err);
          this.isSubmit = false;
        }
      }
    },
    concatUsername(appId, email) {
      if (this.isCognitoType) {
        return email;
      }

      return `${email}_app_${appId}`;
    },
    setError(err) {
      this.error = err.message || err;
    },
    checkLoginType(query) {
      const { type } = query;
      this.isCognitoType = type === 'cognito';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/authenticator/SignUp.vue